import request from '../../config/axiosConfig';
import {
  GET_LIST_PREMIUM_TYPES, GET_PREMIUM_TYPE_INFO, CREATE_PREMIUM_TYPE,
  UPDATE_PREMIUM_TYPE, DELETE_PREMIUM_TYPE, LIST_ACTIVE_PREMIUM_TYPES
} from '../../constants/apiEndPoint';

export const getListPremiumTypesRequest = async (data) => {
  const result = await request({ url: GET_LIST_PREMIUM_TYPES, method: 'POST', data });
  return result?.data.data;
};

export const getPremiumTypeInfoRequest = async (data) => {
  const result = await request({ url: GET_PREMIUM_TYPE_INFO, method: 'POST', data });
  return result?.data.data;
};

export const createPremiumTypeRequest = async (data) => {
  const result = await request({ url: CREATE_PREMIUM_TYPE, method: 'POST', data });
  return result?.data;
};

export const updatePremiumTypeRequest = async (data) => {
  const result = await request({ url: UPDATE_PREMIUM_TYPE, method: 'POST', data });
  return result?.data;
};

export const deletePremiumTypeRequest = async (data) => {
  const result = await request({ url: DELETE_PREMIUM_TYPE, method: 'POST', data });
  return result?.data;
};

export const listActivePremiumTypesRequest = async (data) => {
  const result = await request({ url: LIST_ACTIVE_PREMIUM_TYPES, method: 'POST', data });
  return result?.data.data;
};
